import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "BurgerMenustyles__Container",
  componentId: "pantheon__sc-1gwxnlt-0"
})(["width:2rem;height:auto;z-index:2000;&:hover{cursor:pointer;}"]);
var Bar = styled.div.withConfig({
  displayName: "BurgerMenustyles__Bar",
  componentId: "pantheon__sc-1gwxnlt-1"
})(["width:100%;height:0.2rem;background-color:", ";margin:0.5rem 0;transition:0.4s;"], function (props) {
  return props.color ? props.color : "#333";
});
var TopBar = styled(Bar).withConfig({
  displayName: "BurgerMenustyles__TopBar",
  componentId: "pantheon__sc-1gwxnlt-2"
})(["", ""], function (props) {
  return props.open ? "\n    transform-origin: center;\n    -webkit-transform: translateY(0.7rem) rotate(-45deg);\n    transform: translateY(0.7rem) rotate(-45deg);\n  " : "";
});
var BottomBar = styled(Bar).withConfig({
  displayName: "BurgerMenustyles__BottomBar",
  componentId: "pantheon__sc-1gwxnlt-3"
})(["", ""], function (props) {
  return props.open ? "\n    transform-origin: center;\n    -webkit-transform: translateY(-0.7rem) rotate(45deg);\n    transform: translateY(-0.7rem) rotate(45deg);\n  " : "";
});
var MiddleBar = styled(Bar).withConfig({
  displayName: "BurgerMenustyles__MiddleBar",
  componentId: "pantheon__sc-1gwxnlt-4"
})(["", ""], function (props) {
  return props.open ? "\n    opacity: 0;\n    margin: 0;\n  " : "";
});
export { MiddleBar, TopBar, BottomBar, Container };